import React, { Dispatch, useCallback, useEffect, useRef, useState } from "react";
import { InfoType, ItemTypes, PopupsListType } from "../RightSideMenu";
import loadIco from "../../assets/loading-ico.gif";
import closeIco from "../../assets/close-icon-color.png";
import { earlyWarning } from "../../../mainLayer/earlyWarning/ShowEarlyWarning";
import { hzIncidents } from "../../../mainLayer/hazardIncidentsLayers/IncidentsMenuDropDown";
import { DetailsTypeDataTable } from "../../../mainLayer/summeryComp/detailsSum/DetailTypeDataTable";
import HzTypeDataTable from "../../../mainLayer/summeryComp/detailsSum/HzTypeDataTable";
import { EWSDataTable } from "../../../mainLayer/summeryComp/detailsSum/EWSDataTable";
import ReactDOM from "react-dom";
import Overlay from "ol/Overlay";
import { map } from "../../../mainLayer/MainLayer";
import DetailsEWSeverity from "../../../mainLayer/summeryComp/detailsSum/detailsEWSeverity";

type SideMenuPopupsType = {
  setWindowState: Dispatch<React.SetStateAction<boolean>>;
  filterEws: earlyWarning[];
  ewSeverityWindow: Dispatch<React.SetStateAction<boolean>>;
  data: InfoType;
  removeItem: (id: string, type: ItemTypes) => void;
  addItem: (id: string, type: ItemTypes) => void;
  onClose: () => void;
  SumSeverityAdd:boolean
  onCloseSeverityPopup: () => void;
};

let severityAll: earlyWarning[] = [];

const SumServerity = (props: SideMenuPopupsType) => {
  const handleClosePopupClick = () => {
    props.setWindowState((prevState) => false);
    props.ewSeverityWindow(false);
    severityAll = [];
    props.onCloseSeverityPopup();
  };

  const [isNotRelease, setIsNotRelease] = useState<boolean>(true);
  const popupRef = useRef<HTMLDivElement | null>(null);
  const [accumulatedEws, setAccumulatedEws] = useState<earlyWarning[]>([]);
  const fulServerity = useRef<earlyWarning[]>([]);
  const popupElement = document.createElement("earlyWarningElement");

  useEffect(() => {
    setAccumulatedEws((prev) => {
      // Combine previous data with new data
      const combinedData = [...prev, ...props.filterEws];
  
      // Use a Map to deduplicate by w_id
      const uniqueData = Array.from(
        new Map(combinedData.map((item) => [item.active_pcode, item])).values()
      );
      fulServerity.current = uniqueData;
      if(!props.SumSeverityAdd){
        severityAll=fulServerity.current;
      }
    
      return uniqueData;
    });
  }, [props.filterEws]);

  const mouseMoveEvent = useCallback(
    (event: MouseEvent) => {
      const sideMenu = document.getElementById("side-menu-wrapper");

      if (sideMenu && isNotRelease) {
        const sideMenuWidth = Number(
          window.getComputedStyle(sideMenu).left.slice(0, -2)
        );

        if (sideMenuWidth > event.clientX && accumulatedEws.length > 0 && (accumulatedEws.length === fulServerity.current.length)) {
          ReactDOM.render(
            <DetailsEWSeverity
            onClose={props.onClose}
            earlyWarningsFromChild={props.SumSeverityAdd?severityAll:accumulatedEws}
            addItem={props.addItem}
            id={props.data.id}
          />
          ,
            popupElement
          );

          const overlay = new Overlay({
            element: popupElement,
            autoPan: {
              animation: {
                duration: 250,
              },
            },
          });

          overlay.setPosition([7.873054, 80.771797]);
          map.addOverlay(overlay);
          props.removeItem(props.data.id, "sumServerity");
          setIsNotRelease(false);
        }
      }
    },
    [isNotRelease,accumulatedEws]
  );

  const mouseMoveEventTouch = useCallback(
    (event: TouchEvent) => {
      const sideMenu = document.getElementById("side-menu-wrapper");

      if (sideMenu && isNotRelease) {
        const sideMenuWidth = Number(
          window.getComputedStyle(sideMenu).left.slice(0, -2)
        );

        const touchX = event.touches[0].clientX;

        if (sideMenuWidth > touchX && accumulatedEws.length > 0 && (accumulatedEws.length === fulServerity.current.length)) {
          ReactDOM.render(
            <DetailsEWSeverity
            onClose={props.onClose}
            earlyWarningsFromChild={props.SumSeverityAdd?severityAll:accumulatedEws}
            addItem={props.addItem}
            id={props.data.id}
          />
          ,
            popupElement
          );

          const overlay = new Overlay({
            element: popupElement,
            autoPan: {
              animation: {
                duration: 250,
              },
            },
          });

          overlay.setPosition([7.873054, 80.771797]);
          map.addOverlay(overlay);
          props.removeItem(props.data.id, "sumServerity");
          setIsNotRelease(false);
        }
      }
    },
    [isNotRelease,accumulatedEws]
  );
 
useEffect(() => {
      const handleMouseDown = () => {
        document.addEventListener("mousemove", mouseMoveEvent);
        document.addEventListener("mouseup", handleMouseUp);
      };
    
      const handleMouseUp = () => {
        document.removeEventListener("mousemove", mouseMoveEvent);
        document.removeEventListener("mouseup", handleMouseUp);
      };
    
      const handleTouchStart = () => {
        document.addEventListener("touchmove", mouseMoveEventTouch);
        document.addEventListener("touchend", handleTouchEnd);
      };
    
      const handleTouchEnd = () => {
        document.removeEventListener("touchmove", mouseMoveEventTouch);
        document.removeEventListener("touchend", handleTouchEnd);
      };
    
      if (popupRef.current) {
        popupRef.current.addEventListener("mouseenter", () => {
          popupRef.current?.addEventListener("mousedown", handleMouseDown);
          popupRef.current?.addEventListener("touchstart", handleTouchStart);
        });
      }
    
      return () => {
        document.removeEventListener("mousemove", mouseMoveEvent);
        document.removeEventListener("mouseup", handleMouseUp);
        document.removeEventListener("touchmove", mouseMoveEventTouch);
        document.removeEventListener("touchend", handleTouchEnd);
      };
    }, [mouseMoveEvent, mouseMoveEventTouch]);


  return (
    <div className={`popup data-table`} ref={popupRef}>
    <div className={`titleWrapper`}>
        <span>Details by Servirity</span>
        <div className={`titleButtonContainer no-drag`}>
            <i className={`titleIcon fullScreenIco`}></i>
            <i className={`titleIcon closeIco`} onClick={(e) => handleClosePopupClick()} onTouchStart={(e) => handleClosePopupClick()}></i>
        </div>
    </div>
    <div className={`data-table-wrapper no-drag`}>
      <EWSDataTable
            earlyWarningsFromChild={props.SumSeverityAdd?severityAll:props.filterEws}
          />
    </div>
</div>
  );
};

export default SumServerity;